import { ApiRequestStore } from '../../../common/apiRequest.store'

class AddExpertStore extends ApiRequestStore {}

export const addExpertStore: AddExpertStore = new AddExpertStore()
